import { cn } from "@/lib/cn";
import type { EntityViewType } from "@config";
import { forwardRef, type ForwardedRef } from "react";
import { SetWrapperStyled } from "../styles/Array.styled";
import type { DndProperties } from "../types";
import {
  getMobileMediaWidthPercent,
  getMobileSetsPerLine,
  getSetsPerLine,
} from "../utils";

export const Wrapper = forwardRef(
  (
    {
      entity,
      children,
      dndProperties,
    }: {
      entity: EntityViewType;
      id: string;
      children: React.ReactNode;
      dndProperties?: DndProperties;
    },
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const { settings, children: entityChildren } = entity;
    const setsPerLine = getSetsPerLine(entityChildren, settings);
    const DND_STYLE = dndProperties?.style ?? {};
    const DND_ATTRIBUTES = dndProperties?.attributes ?? {};
    const DND_LISTENERS = dndProperties?.listeners ?? {};

    return (
      <SetWrapperStyled
        style={DND_STYLE}
        {...DND_ATTRIBUTES}
        {...DND_LISTENERS}
        ref={ref}
        className={cn("set-wrapper tw-relative", {
          "--is-dragging": !!dndProperties?.isDragging,
        })}
        {...STYLED_PROPS({
          settings,
          setsPerLine,
          total: entityChildren.length,
        })}
      >
        {children}
      </SetWrapperStyled>
    );
  },
);

const STYLED_PROPS = ({
  settings,
  setsPerLine,
  total,
}: {
  settings: Record<string, any>;
  setsPerLine: number;
  total: number;
}) => {
  const mobileSetsPerLine = getMobileSetsPerLine(settings);
  const isNarrow = settings.maxWidth === "narrow";
  return {
    $maxWidth: settings.maxWidth,
    $setsSpace: Number(settings.setsSpace),
    $setsPerLine: setsPerLine,
    $mobileSetsPerLine: mobileSetsPerLine,
    $mobileMediaWidth:
      mobileSetsPerLine > 2
        ? 100
        : getMobileMediaWidthPercent(setsPerLine, isNarrow),
    $verticalAlignment: settings.verticalAlignment,
    $horizontalAlignment: settings.horizontalAlignment,
    $totalItems: total,
  };
};
